export default __webpack_public_path__ + "static/media/youtube-icon.c2bb2f46.svg";